import { useState } from "react";
import React = require("react");
import { PublicAmorgUser } from '../../../amorg-common';
import { MessageCard } from "../../../designSystem/MessageCard";
import { IndividualMemberPermission, IndividualPermissions, PermissionGroupId, PermissionGroups } from '../../../amorg-common';
import { txt } from "../../../txt";
import { permissionHelper } from '../../../amorg-common';
import { H2 } from "../../../designSystem/typography/Heading";
import { assignUserIndividualPermission, updatePermissionGroup } from "../../../api/userClientApi";
import { Select } from "../../../designSystem/inputs/Select";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Checkbox } from "../../../designSystem/inputs/Checkbox";

type PermissionGroupEditorProps = {
	activeUser:PublicAmorgUser;
	targetUser:PublicAmorgUser;
    onSelectedUserUpdated:()=>void;
}
export function PermissionGroupEditor({activeUser, targetUser, onSelectedUserUpdated}:PermissionGroupEditorProps)
{
	const canEdit = permissionHelper.canAdminEditTargetGroupId(
		activeUser.permissionGroup.id, 
		targetUser.permissionGroup.id,
		activeUser.id === targetUser.id
	);

	return (
		<Flex flexDirection="column" gap={4}>
			<H2>Rettighedsniveau</H2>
			{!canEdit &&
				<>
					{txt.getDynamic(`PermissionGroupId_${targetUser.permissionGroup.id}`)}
				</>
			}
			
			{canEdit  &&
				<AdminPermissionGroupEditor
					activeUser={activeUser}
					targetUser={targetUser}
					onSelectedUserUpdated={onSelectedUserUpdated} />
			}
		</Flex>
	);
}

type AdminPermissionGroupEditorProps = {
	activeUser:PublicAmorgUser;
	targetUser:PublicAmorgUser;
    onSelectedUserUpdated:()=>void;
}
export function AdminPermissionGroupEditor({activeUser, targetUser: selectedUser, onSelectedUserUpdated}:AdminPermissionGroupEditorProps)
{
	const [selectedPermissionGroupId, setSelectedPermissionGroupId] = useState<PermissionGroupId>(selectedUser.permissionGroup.id);
	const [error, setError] = useState('');
	const canEditIndividualPermissions = selectedPermissionGroupId === 'member';

	async function handlePermissionGroupChange(val:string){
		const result = await updatePermissionGroup(selectedUser.id, val);
        if(!result.isSuccess)
            setError("Ændringen kunne ikke gennemføres");
        else{
            setError('');
			setSelectedPermissionGroupId(val as PermissionGroupId);
			onSelectedUserUpdated();
        }   
	}

	async function handleIndividualPermissionChange(permission: IndividualMemberPermission, assigned: boolean)
	{
		await assignUserIndividualPermission(selectedUser.id, permission, assigned);
		onSelectedUserUpdated();
	}

	const availablePermissionIds = [ PermissionGroups.user.id, PermissionGroups.member.id ];
	if(activeUser.permissionGroup.permissions.includes('SuperAdmin')){
		availablePermissionIds.push(PermissionGroups.siteAdmin.id);
    }

	return (
		<>
			<Select
				id="permission"
				selectedValue={selectedPermissionGroupId} 
				options={availablePermissionIds.map(p => new Option(txt.getDynamic(`PermissionGroupId_${p}`), p))}
				onChange={handlePermissionGroupChange}
                disabled={!selectedUser.enabled} />

			{error !== '' && 
				<MessageCard variant={'error'}>{error}</MessageCard>
			}

			{canEditIndividualPermissions &&
				<Flex flexDirection="column" gap={2}>
					{IndividualPermissions.map((permission) => (
						<Checkbox
							key={permission}
							text="Kan se og håndtere indberetninger"
							value={permission}
							checked={selectedUser.individualPermissions.includes(permission)}
							onChange={(_, checked) => void handleIndividualPermissionChange(permission, checked)}
							disabled={!selectedUser.enabled}
						/>
					))}
				</Flex>
			}
		</>
	);
}